import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingCropSales, setFootprintingCropSalesAdmin } from "services";

import { footprintingCropPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_CROP_PURCHASERS, FOOTPRINTING_CROP_SALES } from "consts";

import { FootprintingCropSalesPayload } from "models";

export const useMutateFootprintingCropSales = (farmId: string, cropId: string, year: number, payload: FootprintingCropSalesPayload, primaryDataId: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? setFootprintingCropSalesAdmin : setFootprintingCropSales;

  return useMutation(
    {
      mutationKey: [FOOTPRINTING_CROP_SALES, primaryDataId, isAdmin],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_CROP_PURCHASERS, farmId, isAdmin],
          [FOOTPRINTING_CROP_SALES, primaryDataId, isAdmin],
          ...footprintingCropPrimaryQueryKeys(primaryDataId, farmId, cropId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
